interface AppleRemindersIconProps {
  className?: string;
  size?: number;
}

export const AppleRemindersIcon = ({
  className,
  size = 32,
}: AppleRemindersIconProps) => {
  return (
    <div>
      <svg
        width={size}
        height={size}
        className={className}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0" y="0" width="100" height="100" rx="20" fill="white" />
        <circle cx="15" cy="28" r="5" fill="#007AFF" />
        <rect x="28" y="26" width="58" height="4" rx="2" fill="#E5E5EA" />
        <circle cx="15" cy="48" r="5" fill="#FF9500" />
        <rect x="28" y="46" width="58" height="4" rx="2" fill="#E5E5EA" />
        <circle cx="15" cy="68" r="5" fill="#FF3B30" />
        <rect x="28" y="66" width="58" height="4" rx="2" fill="#E5E5EA" />
      </svg>
    </div>
  );
};
